<template>
  <vs-checkbox v-model="fl">{{label}}</vs-checkbox>
</template>

<script>
export default {
  name: "SearchNavItemFinishLater",
  props: {
    label: {
      type: String,
      default: "추후보완",
    },
    value: [Boolean, String],
  },
  watch: {
    value(value) {
      this.fl = value;
    },
    fl(value) {
      this.$emit("input", value);
    }
  },
  computed: {
    isFinishLater () {
      const query = this.$route.query;
      if (`${query.fl}` === 'true') {
        return query.fl
      }
      return false
    },
  },
  data() {
    return {
      fl: false,
    };
  },
  created() {
    this.fl = this.isFinishLater
  },
};
</script>

<style scoped>

</style>
